<template>
  <layout title="Entregas" :options="options" :rotas="rotas">
    <section class="deliveries-page" :class="{ 'deliveries-page-dark': $theme.dark }">
      <div class="deliveries-toolbar">
        <!-- <v-text-field
          dense
          filled
          :dark="$theme.dark"
          hide-details
          clearable
          label="Buscar cliente ou venda"
          prepend-inner-icon="mdi-magnify"
          v-model="filters.search"
          @input="debounceLoad"
        />
        <v-select
          dense
          filled
          :dark="$theme.dark"
          hide-details
          clearable
          label="Status"
          :items="statusOptions"
          v-model="filters.status"
          @change="loadData"
        /> -->
        <!-- <v-menu v-model="dateMenu" :close-on-content-click="false" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              dense
              filled
              :dark="$theme.dark"
              hide-details
              readonly
              clearable
              label="Data"
              prepend-inner-icon="mdi-calendar"
              v-bind="attrs"
              v-on="on"
              v-model="filters.date"
              @click:clear="loadData"
            />
          </template>
          <v-date-picker :dark="$theme.dark" v-model="filters.date" @input="dateMenu = false; loadData()" />
        </v-menu> -->
        <!-- <v-select
          dense
          filled
          :dark="$theme.dark"
          hide-details
          clearable
          label="Polo"
          item-text="nome"
          return-object
          :items="unities"
          v-model="filters.unity"
          @change="loadData"
        /> -->
        <!-- <v-switch
          v-if="canSeeAll"
          :dark="$theme.dark"
          inset
          hide-details
          label="Todas as entregas"
          :input-value="filters.scope === 'all'"
          @change="toggleScope"
        /> -->
      </div>

      <div class="deliveries-summary" role="tablist" aria-label="Status das entregas">
        <button
          v-for="status in deliveryStatusTabs"
          :key="status.value"
          type="button"
          class="delivery-status-pill"
          :class="[`delivery-status-pill-${status.value}`, { active: filters.status === status.value }]"
          role="tab"
          :aria-selected="filters.status === status.value ? 'true' : 'false'"
          @click="setStatusFilter(status.value)"
        >
          <span>{{ status.label }}</span>
          <strong>{{ summary[status.value] || 0 }}</strong>
        </button>
      </div>

      <div class="deliveries-context">
        <div>
          <span>{{ locationLabel }}</span>
          <strong>{{ deliveries.length }} entrega{{ deliveries.length === 1 ? "" : "s" }} na fila</strong>
        </div>
      </div>

      <div v-if="loading && deliveries.length === 0" class="deliveries-skeleton">
        <div v-for="index in 4" :key="index" class="delivery-skeleton-card">
          <v-skeleton-loader type="list-item-avatar-three-line" />
        </div>
      </div>

      <div v-else class="deliveries-grid" :class="{ refreshing: loading }">
        <v-card
          v-for="delivery in deliveries"
          :key="delivery._id"
          class="delivery-card"
          :dark="$theme.dark"
          elevation="0"
          @click="$refs.detail.open(delivery)"
        >
          <div class="delivery-card-head">
            <v-icon :color="getColor(delivery.status)">{{ getIcon(delivery.status) }}</v-icon>
            <div>
              <strong>{{ clientName(delivery) }}</strong>
              <span>Venda #{{ saleNumber(delivery) }}</span>
            </div>
            <v-chip x-small :color="getColor(delivery.status)" text-color="white">{{ getStatus(delivery.status) }}</v-chip>
          </div>
          <div class="delivery-card-body">
            <p><v-icon size="18">mdi-map-marker-outline</v-icon>{{ addressLabel(delivery.address_destiny) }}</p>
            <div class="delivery-meta-line">
              <span><v-icon size="16">mdi-calendar-clock</v-icon>{{ delivery.visit_date }} {{ delivery.visit_hour }}</span>
              <span><v-icon size="16">mdi-map-marker-distance</v-icon>{{ distanceLabel(delivery) }}</span>
            </div>
            <div class="delivery-meta-line">
              <span><v-icon size="16">mdi-account-hard-hat-outline</v-icon>{{ userName(delivery.executor) }}</span>
              <span><v-icon size="16">mdi-truck-outline</v-icon>{{ vehicleLabel(delivery.vehicle) }}</span>
            </div>
          </div>
          <div class="delivery-card-actions" @click.stop>
            <v-btn
              v-if="delivery.status === 'waiting'"
              small
              depressed
              color="green"
              dark
              :loading="isActionLoading(delivery, 'on_the_way')"
              @click="changeStatus(delivery, 'on_the_way')"
            >
              <v-icon left small>mdi-play</v-icon>Iniciar
            </v-btn>
            <v-spacer />
            <v-btn icon small class="delivery-action-button" title="Abrir venda" :to="`/gestordepedidos/venda/${delivery.transaction}`">
              <v-icon>mdi-file-document-outline</v-icon>
            </v-btn>
          </div>
        </v-card>
      </div>

      <div v-if="!loading && deliveries.length === 0" class="deliveries-empty">
        <v-icon size="46" color="#9aa7a0">mdi-truck-delivery-outline</v-icon>
        <strong>Nenhuma entrega encontrada</strong>
      </div>
      <delivery-detail-dialog ref="detail" @status="changeStatus" @comment="addComment" />
    </section>
  </layout>
</template>

<script>
import _ from "lodash";
import DeliveryDetailDialog from "../components/DeliveryDetailDialog.vue";

export default {
  components: {
    DeliveryDetailDialog
  },
  data() {
    return {
      loading: false,
      dateMenu: false,
      deliveriesPayload: {
        docs: [],
        summary: {}
      },
      currentLocation: null,
      locationStatus: "pending",
      activeRouteDelivery: null,
      actionLoading: null,
      locationWatchId: null,
      unities: [],
      filters: {
        search: "",
        status: "waiting",
        date: "",
        scope: "mine",
        unity: null
      },
      deliveryStatusTabs: [
        { label: "Agendadas", value: "waiting" },
        { label: "Em rota", value: "on_the_way" },
        { label: "Concluídas", value: "done" },
        { label: "Canceladas", value: "canceled" }
      ],
      statusOptions: [
        { text: "Agendada", value: "waiting" },
        { text: "Em rota", value: "on_the_way" },
        { text: "Concluída", value: "done" },
        { text: "Cancelada", value: "canceled" }
      ],
      rotas: [
        { name: "Início", path: "/dashboard" },
        { name: "Entregas", path: "/entregas" }
      ],
      options: [
        {
          icon: "mdi-update",
          nome: "Atualizar",
          action: () => this.loadData()
        }
      ],
      realtimeHandler: null
    };
  },
  computed: {
    deliveries() {
      const docs = (this.deliveriesPayload.docs || []).map(delivery => ({
        ...delivery,
        distance_km: this.distanceFromCurrent(delivery)
      }));
      if (!this.currentLocation) return docs;
      return docs.sort((a, b) => {
        const distanceA = this.hasDistance(a.distance_km) ? Number(a.distance_km) : Number.MAX_SAFE_INTEGER;
        const distanceB = this.hasDistance(b.distance_km) ? Number(b.distance_km) : Number.MAX_SAFE_INTEGER;
        if (distanceA !== distanceB) return distanceA - distanceB;
        return String(a.visit_date || "").localeCompare(String(b.visit_date || ""));
      });
    },
    summary() {
      return this.deliveriesPayload.summary || {};
    },
    canSeeAll() {
      return Boolean(this.$store.getters.get_permission_user["ver-entregas"]);
    },
    locationLabel() {
      if (this.locationStatus === "ready") return "Localização ativa";
      if (this.locationStatus === "denied") return "Localização bloqueada";
      if (this.locationStatus === "unavailable") return "Localização indisponível";
      return "Buscando localização";
    }
  },
  methods: {
    loadUnities() {
      this.$run("unidades/list", { limitPerPage: 2000 })
        .then(res => {
          this.unities = res.data.docs || [];
        })
        .catch(() => {});
    },
    loadData() {
      this.loading = true;
      const payload = {
        ...this.filters,
        driver_location: this.currentLocation
      };
      this.$run("external_movimentations/list-my-deliveries", payload)
        .then(res => {
          this.deliveriesPayload = res.data || { docs: [], summary: {} };
          this.openRouteEvent();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    debounceLoad: _.debounce(function() {
      this.loadData();
    }, 450),
    toggleScope(value) {
      this.filters.scope = value ? "all" : "mine";
      this.loadData();
    },
    setStatusFilter(status) {
      if (this.filters.status === status) return;
      this.filters.status = status;
      this.loadData();
    },
    changeStatus(delivery, status) {
      if (!delivery || !delivery._id) return;
      this.actionLoading = `${delivery._id}:${status}`;
      this.loading = true;
      this.$run("external_movimentations/update-status", {
        _id: delivery._id,
        old_group_name: delivery.status,
        new_group_name: status,
        novo_status: status,
        driver_location: this.currentLocation
      }).then(res => {
        if (status === "on_the_way") {
          this.activeRouteDelivery = { ...delivery, ...(res.data || {}), status };
          this.$router.push(`/entregas/player/${delivery._id}`);
          return;
        }
        this.loadData();
      }).catch(error => {
        console.error(error);
        if (status === "on_the_way") {
          this.activeRouteDelivery = { ...delivery, status };
          this.$router.push(`/entregas/player/${delivery._id}`);
        }
      }).finally(() => {
        this.actionLoading = null;
        this.loading = false;
      });
    },
    isActionLoading(delivery, status) {
      return this.actionLoading === `${delivery && delivery._id}:${status}`;
    },
    addComment(delivery, comment) {
      if (!delivery || !delivery._id || !comment) return;
      this.$run("external_movimentations/add-comment", {
        _id: delivery._id,
        comment
      }).then(() => this.loadData());
    },
    openRouteEvent() {
      const eventId = this.$route.query.event || this.$route.query.e_id;
      if (!eventId || !this.$refs.detail) return;
      const delivery = this.deliveries.find(item => String(item._id) === String(eventId));
      if (delivery) this.$refs.detail.open(delivery);
    },
    requestDriverLocation() {
      this.startDriverLocationWatch();
    },
    startDriverLocationWatch() {
      if (!navigator.geolocation) {
        this.locationStatus = "unavailable";
        this.loadData();
        return;
      }
      if (this.locationWatchId !== null) return;
      this.locationStatus = "pending";
      this.locationWatchId = navigator.geolocation.watchPosition(
        position => {
          const location = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            accuracy: position.coords.accuracy,
            updated_at: new Date().toISOString()
          };
          this.currentLocation = location;
          this.locationStatus = "ready";
          this.syncDriverLocation(location);
        },
        error => {
          this.locationStatus = error && error.code === 1 ? "denied" : "unavailable";
          this.loadData();
        },
        { enableHighAccuracy: true, timeout: 15000, maximumAge: 10000 }
      );
    },
    stopDriverLocationWatch() {
      if (this.locationWatchId === null || !navigator.geolocation) return;
      navigator.geolocation.clearWatch(this.locationWatchId);
      this.locationWatchId = null;
    },
    syncDriverLocation: _.throttle(function(location) {
      if (!location) return;
      this.$run("external_movimentations/track-driver-location", {
        driver_location: location
      }).catch(() => {});
      this.loadData();
    }, 15000, { leading: true, trailing: true }),
    normalizeCoordinate(value) {
      const number = Number(value);
      return Number.isFinite(number) ? number : null;
    },
    coordinatesFrom(value = {}) {
      if (!value) return null;
      const candidates = [
        value,
        value.location,
        value.coordinates,
        value.geo,
        value.position,
        value.geometry && value.geometry.location,
        value.current_location,
        value.last_location,
        value.address_destiny,
        value.address_destiny && value.address_destiny.location,
        value.address_destiny && value.address_destiny.coordinates,
        value.address_destiny && value.address_destiny.geometry && value.address_destiny.geometry.location,
        value.destination,
        value.delivery_address,
        value.delivery_address && value.delivery_address.location,
        value.delivery_address && value.delivery_address.coordinates,
        value.delivery_address && value.delivery_address.geometry && value.delivery_address.geometry.location,
        value.address,
        value.address && value.address.location,
        value.address && value.address.coordinates,
        value.address && value.address.geometry && value.address.geometry.location,
        value.endereco,
        value.endereco && value.endereco.location,
        value.endereco && value.endereco.coordinates,
        value.endereco && value.endereco.geometry && value.endereco.geometry.location
      ];
      for (const candidate of candidates) {
        const lat = this.normalizeCoordinate(candidate && (candidate.lat || candidate.latitude));
        const lng = this.normalizeCoordinate(candidate && (candidate.lng || candidate.lon || candidate.long || candidate.longitude));
        if (lat !== null && lng !== null) return { lat, lng };
      }
      return null;
    },
    deliveryDestinationCoordinates(delivery = {}) {
      const candidates = [
        delivery.address_destiny,
        delivery.destination,
        delivery.delivery_address,
        delivery.address,
        delivery.endereco,
        delivery.sale_summary && delivery.sale_summary.address_destiny,
        delivery.sale_summary && delivery.sale_summary.delivery_address,
        delivery.sale_summary && delivery.sale_summary.address,
        delivery.sale_summary && delivery.sale_summary.compra && delivery.sale_summary.compra.address_destiny,
        delivery.sale_summary && delivery.sale_summary.compra && delivery.sale_summary.compra.delivery_address,
        delivery.sale_summary && delivery.sale_summary.compra && delivery.sale_summary.compra.endereco,
        delivery.client && delivery.client.address,
        delivery.client && delivery.client.endereco
      ];
      for (const candidate of candidates) {
        const coords = this.coordinatesFrom(candidate);
        if (coords) return coords;
      }
      return null;
    },
    savedDistanceFrom(delivery = {}) {
      const candidates = [
        delivery.route_summary && delivery.route_summary.distance_km,
        delivery.distance_km,
        delivery.distanceKm,
        delivery.distance,
        delivery.distancia_km,
        delivery.distancia,
        delivery.sale_summary && delivery.sale_summary.distance_km,
        delivery.sale_summary && delivery.sale_summary.distance,
        delivery.sale_summary && delivery.sale_summary.distancia_km,
        delivery.sale_summary && delivery.sale_summary.distancia,
        delivery.sale_summary && delivery.sale_summary.compra && delivery.sale_summary.compra.distance_km,
        delivery.sale_summary && delivery.sale_summary.compra && delivery.sale_summary.compra.distance,
        delivery.sale_summary && delivery.sale_summary.compra && delivery.sale_summary.compra.distancia_km,
        delivery.sale_summary && delivery.sale_summary.compra && delivery.sale_summary.compra.distancia
      ];
      const value = candidates.find(candidate => this.hasDistance(candidate));
      return this.hasDistance(value) ? Number(value) : null;
    },
    routeDistanceText(delivery = {}) {
      return delivery.route_summary && delivery.route_summary.distance_text ||
        delivery.distance_text ||
        delivery.sale_summary && delivery.sale_summary.distance_text ||
        delivery.sale_summary && delivery.sale_summary.compra && delivery.sale_summary.compra.distance_text ||
        "";
    },
    formatDistance(distance) {
      if (!this.hasDistance(distance)) return "Distância indisponível";
      if (distance < 1) return `${Math.round(distance * 1000)} m`;
      return `${Number(distance).toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })} km`;
    },
    distanceInKm(origin, destination) {
      const from = this.coordinatesFrom(origin);
      const to = this.coordinatesFrom(destination);
      if (!from || !to) return null;
      const radius = 6371;
      const toRadians = degrees => degrees * Math.PI / 180;
      const deltaLat = toRadians(to.lat - from.lat);
      const deltaLng = toRadians(to.lng - from.lng);
      const a =
        Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
        Math.cos(toRadians(from.lat)) *
        Math.cos(toRadians(to.lat)) *
        Math.sin(deltaLng / 2) *
        Math.sin(deltaLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return Math.round(radius * c * 10) / 10;
    },
    distanceFromCurrent(delivery) {
      const savedDistance = this.savedDistanceFrom(delivery);
      if (this.hasDistance(savedDistance)) return Number(savedDistance);
      if (!this.currentLocation) return null;
      return this.distanceInKm(this.currentLocation, this.deliveryDestinationCoordinates(delivery));
    },
    hasDistance(value) {
      return value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value));
    },
    distanceLabel(delivery) {
      const routeText = this.routeDistanceText(delivery);
      if (routeText) return routeText;
      return this.formatDistance(this.distanceFromCurrent(delivery));
    },
    clientName(delivery) {
      return delivery.client && delivery.client.nome ||
        delivery.sale_summary && delivery.sale_summary.client && delivery.sale_summary.client.nome ||
        "Cliente não informado";
    },
    saleNumber(delivery) {
      return delivery.sale_summary && delivery.sale_summary.id_transacao || delivery.transaction || "-";
    },
    userName(user) {
      return user && user.nome || "Não informado";
    },
    vehicleLabel(vehicle) {
      if (!vehicle) return "Sem veículo";
      return [vehicle.placa, vehicle.modelo].filter(Boolean).join(" - ") || "Sem veículo";
    },
    addressLabel(address = {}) {
      return [
        address.street,
        address.number ? `nº ${address.number}` : "",
        address.bairro,
        address.city || address.cidade,
      ].filter(Boolean).join(", ") || "Endereço não informado";
    },
    getColor(status) {
      return {
        waiting: "orange",
        on_the_way: "green",
        done: "blue",
        canceled: "red"
      }[status] || "grey";
    },
    getStatus(status) {
      return {
        waiting: "Agendada",
        on_the_way: "Em rota",
        done: "Concluída",
        canceled: "Cancelada"
      }[status] || status;
    },
    getIcon(status) {
      return {
        waiting: "mdi-clock-outline",
        on_the_way: "mdi-truck-fast-outline",
        done: "mdi-check-circle-outline",
        canceled: "mdi-cancel"
      }[status] || "mdi-truck-delivery-outline";
    }
  },
  created() {
    this.loadUnities();
    this.startDriverLocationWatch();
  },
  mounted() {
    this.realtimeHandler = () => this.loadData();
    window.addEventListener("stonepro:external-movimentation-updated", this.realtimeHandler);
  },
  beforeDestroy() {
    window.removeEventListener("stonepro:external-movimentation-updated", this.realtimeHandler);
    this.stopDriverLocationWatch();
    if (this.syncDriverLocation && this.syncDriverLocation.cancel) this.syncDriverLocation.cancel();
  }
};
</script>

<style scoped>
.deliveries-page {
  background: #f5f7f4;
  min-height: calc(100vh - 72px);
  padding: 18px;
}
.deliveries-page-dark {
  background: #0b1518;
  color: #edf5f2;
}
.deliveries-toolbar {
  align-items: center;
  display: grid;
  gap: 10px;
  grid-template-columns: minmax(220px, 1fr) minmax(140px, 170px) minmax(140px, 170px) minmax(180px, 220px) auto;
  margin-bottom: 12px;
}
.deliveries-summary {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-bottom: 12px;
}
.delivery-status-pill {
  align-items: center;
  background: #ffffff;
  border: 1px solid #dce7df;
  border-radius: 999px;
  color: #50635a;
  cursor: pointer;
  display: flex;
  gap: 8px;
  justify-content: space-between;
  min-height: 38px;
  min-width: 0;
  padding: 7px 12px;
  transition: background .2s ease, border-color .2s ease, color .2s ease, box-shadow .2s ease;
}
.delivery-status-pill span {
  font-size: 12px;
  font-weight: 700;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}
.delivery-status-pill strong {
  align-items: center;
  background: rgba(36, 55, 48, .08);
  border-radius: 999px;
  color: inherit;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 12px;
  justify-content: center;
  min-width: 26px;
  padding: 2px 8px;
}
.delivery-status-pill.active {
  box-shadow: 0 10px 24px rgba(18, 91, 64, .14);
}
.delivery-status-pill-waiting.active {
  background: #fff4e5;
  border-color: #f6aa3b;
  color: #9a5b00;
}
.delivery-status-pill-on_the_way.active {
  background: #e8f7ef;
  border-color: #26a269;
  color: #087044;
}
.delivery-status-pill-done.active {
  background: #eaf3ff;
  border-color: #2d7fd2;
  color: #155fa8;
}
.delivery-status-pill-canceled.active {
  background: #fff0f0;
  border-color: #e45d5d;
  color: #b42323;
}
.deliveries-page-dark .delivery-status-pill {
  background: #101f24;
  border-color: #244149;
  color: #cfe0da;
}
.deliveries-page-dark .delivery-status-pill strong {
  background: rgba(255, 255, 255, .1);
}
.deliveries-page-dark .delivery-status-pill-waiting.active {
  background: rgba(246, 170, 59, .16);
  color: #ffdca8;
}
.deliveries-page-dark .delivery-status-pill-on_the_way.active {
  background: rgba(38, 162, 105, .18);
  color: #99ecc4;
}
.deliveries-page-dark .delivery-status-pill-done.active {
  background: rgba(45, 127, 210, .18);
  color: #aad4ff;
}
.deliveries-page-dark .delivery-status-pill-canceled.active {
  background: rgba(228, 93, 93, .18);
  color: #ffc1c1;
}
.deliveries-context {
  align-items: center;
  background: #ffffff;
  border: 1px solid #dde6df;
  border-radius: 8px;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 14px;
  padding: 12px 14px;
}
.deliveries-page-dark .deliveries-context {
  background: #101f24;
  border-color: #244149;
}
.deliveries-context span {
  color: #65746b;
  display: block;
  font-size: 12px;
}
.deliveries-context strong {
  color: #172820;
  display: block;
  font-size: 18px;
  line-height: 1.2;
}
.deliveries-page-dark .deliveries-context span {
  color: #b7c8c2;
}
.deliveries-page-dark .deliveries-context strong {
  color: #f2fbf7;
}
.deliveries-skeleton {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
}
.delivery-skeleton-card {
  background: #ffffff;
  border: 1px solid #dde6df;
  border-radius: 8px;
  padding: 10px;
}
.deliveries-page-dark .delivery-skeleton-card {
  background: #101f24;
  border-color: #244149;
}
.deliveries-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  position: relative;
}
.deliveries-grid.refreshing {
  opacity: .68;
  pointer-events: none;
}
.delivery-card {
  border: 1px solid #dde6df;
  border-radius: 8px;
  cursor: pointer;
  padding: 14px;
}
.deliveries-page-dark .delivery-card {
  background: #101f24 !important;
  border-color: #244149;
}
.delivery-card-head,
.delivery-card-actions {
  align-items: center;
  display: flex;
  gap: 10px;
}
.delivery-card-head div {
  flex: 1;
  min-width: 0;
}
.delivery-card-head strong,
.delivery-card-head span {
  display: block;
}
.delivery-card-head strong {
  color: #172820;
  line-height: 1.25;
}
.delivery-card-head span,
.delivery-card-body p {
  color: #65746b;
  font-size: 12px;
}
.deliveries-page-dark .delivery-card-head strong {
  color: #f2fbf7;
}
.deliveries-page-dark .delivery-card-head span,
.deliveries-page-dark .delivery-card-body p {
  color: #b7c8c2;
}
.delivery-card-body {
  display: grid;
  gap: 8px;
  margin: 14px 0;
}
.delivery-card-body p,
.delivery-meta-line,
.delivery-meta-line span {
  align-items: center;
  display: flex;
  gap: 6px;
  margin: 0;
}
.delivery-meta-line {
  gap: 12px;
  justify-content: space-between;
}
.delivery-meta-line span {
  min-width: 0;
}
.delivery-meta-line span:first-child {
  flex: 1;
}
.delivery-card-body .v-icon {
  flex: 0 0 auto;
}
.delivery-action-button {
  background: rgba(35, 55, 48, 0.08);
}
.deliveries-page-dark .delivery-action-button {
  background: rgba(255, 255, 255, 0.08);
}
.deliveries-empty {
  align-items: center;
  color: #5f6f66;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  min-height: 260px;
  text-align: center;
}
.deliveries-page-dark .deliveries-empty {
  color: #c5d4cf;
}
@media(max-width: 1100px) {
  .deliveries-toolbar {
    grid-template-columns: 1fr;
  }
}
@media(max-width: 720px) {
  .deliveries-page {
    min-height: calc(100vh - 56px);
    padding: 12px;
  }
  .deliveries-toolbar {
    gap: 8px;
    margin-bottom: 10px;
  }
  .deliveries-summary {
    gap: 8px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .deliveries-context {
    padding: 11px 12px;
  }
  .deliveries-context strong {
    font-size: 16px;
  }
  .deliveries-grid {
    grid-template-columns: 1fr;
  }
  .deliveries-skeleton {
    grid-template-columns: 1fr;
  }
  .delivery-card {
    padding: 14px 12px;
  }
  .delivery-card-head {
    align-items: flex-start;
  }
  .delivery-card-actions {
    border-top: 1px solid #dde6df;
    margin-top: 12px;
    padding-top: 10px;
  }
  .deliveries-page-dark .delivery-card-actions {
    border-top-color: #244149;
  }
  .delivery-action-button {
    height: 40px !important;
    width: 40px !important;
  }
  .delivery-meta-line {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
}
</style>
